import React, { useState } from 'react';
import { Element } from 'react-scroll';
import PageTopButton from '@components/common/pageTopButton';
import Banner from '@components/acca/results/common/banner';
import PstResult from '@components/phs/pst/results/result';
import Info from '@components/phs/pacc/results/info';
import ResultList from '@components/phs/pst/results/resultList';
import classnames from 'classnames/bind';
import styles from './pstResults.module.scss';

const cx = classnames.bind(styles);

// 내 프로필 > 개발자 검사 결과 > 개발구현능력 검사
const PstResults = () => {
  const [sn, setSn] = useState<number | null>(null);

  return (
    <Element name={'result'} className={cx('resultArea')}>
      <div className={cx('resultWrap')}>
        <div className={cx('contentsArea')}>
          <div className={cx('contentsWrap')}>
            {/* 결과 도움말 */}
            <Info />

            {/* 역검 결과 리스트 */}
            <ResultList sn={sn} setSn={setSn} />

            {/* 역검 결과표 */}
            {sn && <PstResult sn={sn} />}
          </div>

          {/* 배너 */}
          <Banner />
        </div>
      </div>

      <PageTopButton />
    </Element>
  );
};

export default PstResults;
